// import request from '@/utils/request'
import axios from 'axios'
import global from '@/global/variable.js'

// 获取日统计数据
export function getTodayReport(data) {
  const url = global.requestUrl + '/statistical/dayReport'
  return axios.get(url)
}

// 获取日统计数据
export function getDayReport(data) {
  const url = global.requestUrl + '/statistical/report?date='+data.date
  return axios.get(url)
}

// 获取日统计数据
export function getMonthReport(data) {
  const url = global.requestUrl + '/statistical/monthReport?month='+data.date
  return axios.get(url)
}

// 获取日统计数据
export function getYearReport(data) {
  const url = global.requestUrl + '/statistical/yearReport?year='+data.date
  return axios.get(url)
}

// 获取日统计数据
export function getEquipmentList(data) {
  const url = global.requestUrl + '/statistical/equipmentState'
  return axios.get(url)
}